(function () {
  if (window.productCardRebuyAjaxCartInitialized) {
    return;
  }

  window.productCardRebuyAjaxCartInitialized = true;

  var formSelector = '.product-card__buy-button form[action*="/cart/add"]';
  var rebuyReadyEvent = 'rebuy:smartcart.ready';
  var rebuyReadyTimeout = 30000;
  var pendingOpen = false;

  function getSmartCart() {
    return window.Rebuy && window.Rebuy.SmartCart;
  }

  function smartCartIsReady() {
    var smartCart = getSmartCart();

    if (!smartCart || typeof smartCart.show !== 'function') {
      return false;
    }

    return !smartCart.status || smartCart.status === 'ready';
  }

  function syncRebuyCart() {
    var rebuyCart = window.Rebuy && window.Rebuy.Cart;

    if (!rebuyCart || typeof rebuyCart.fetchShopifyCart !== 'function') {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var settled = false;
      var timeout = window.setTimeout(done, 750);

      function done() {
        if (settled) {
          return;
        }

        settled = true;
        window.clearTimeout(timeout);
        resolve();
      }

      try {
        var request = rebuyCart.fetchShopifyCart(done);

        if (request && typeof request.then === 'function') {
          request.then(done).catch(done);
        }
      } catch (error) {
        done();
      }
    });
  }

  function openSmartCart() {
    pendingOpen = false;
    syncRebuyCart().then(function () {
      if (smartCartIsReady()) {
        getSmartCart().show();
      }
    });
  }

  function waitForSmartCart() {
    var startedAt = Date.now();

    function checkReady() {
      if (!pendingOpen) {
        return;
      }

      if (smartCartIsReady()) {
        openSmartCart();
        return;
      }

      if (Date.now() - startedAt > rebuyReadyTimeout) {
        pendingOpen = false;
        return;
      }

      window.setTimeout(checkReady, 100);
    }

    checkReady();
  }

  function updateCartBubble() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          return null;
        }

        return response.json();
      })
      .then(function (cart) {
        if (!cart) {
          return;
        }

        document.querySelectorAll('.js-cart-link__bubble, .js-cart-link__bubble-mobile').forEach(function (bubble) {
          bubble.textContent = cart.item_count;
          bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
      });
  }

  function showAddError(form, message) {
    var oldError = form.parentNode.querySelector('.product-card__cart-error');
    var error = document.createElement('div');

    if (oldError) {
      oldError.remove();
    }

    error.className = 'product-card__cart-error errors';
    error.textContent = message;
    form.insertAdjacentElement('afterend', error);
  }

  function resetButton(button, text) {
    if (!button) {
      return;
    }

    button.disabled = false;
    button.classList.remove('is-adding');

    if (text) {
      button.textContent = text;
    }
  }

  document.addEventListener(rebuyReadyEvent, function () {
    if (pendingOpen && smartCartIsReady()) {
      openSmartCart();
    }
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest(formSelector);

      if (!form || event.defaultPrevented) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('button[type="submit"]');
      var buttonText = button ? button.textContent : '';

      if (button && button.disabled) {
        return;
      }

      if (button) {
        button.disabled = true;
        button.classList.add('is-adding');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
        body: new FormData(form),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw data;
            }

            return data;
          });
        })
        .then(function (lineItem) {
          return updateCartBubble().then(function () {
            document.dispatchEvent(
              new CustomEvent('product-card:cart:add', {
                detail: {
                  form: form,
                  lineItem: lineItem,
                },
              }),
            );

            if (smartCartIsReady()) {
              openSmartCart();
            } else {
              pendingOpen = true;
              waitForSmartCart();
            }
          });
        })
        .catch(function (error) {
          showAddError(form, error.description || error.message || 'Unable to add this item to cart.');
        })
        .finally(function () {
          resetButton(button, buttonText);
        });
    },
    true,
  );
})();
